export enum TransportCompanyMemberType {
    DRIVER = 0,
    COMPANION = 1,
    VEHICLE = 2
} 